import { Shelf, ShelfFormData } from "../types/shelf";
import { get, post } from "./fetch.core";

async function listShelves() {
  const res = await get<Shelf[]>("/admin/shelf/list");
  return res.data;
}

async function getShelf(id: string) {
  const res = await get<Shelf>(`/admin/shelf/get?id=${id}`);
  return res.data;
}

async function deleteShelf(id: string) {
  const res = await post("/admin/shelf/delete", { id });
  return res.data;
}

const obj = {
  listShelves,
  getShelf,
  deleteShelf,
};

export default obj;
